import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export function getIsGwp7869() {
    return checkFeatureFlagGate(
        featureFlags.gwp7869NonprofitPricingPageUpdates
    );
}
